import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import { getEnvVar } from '@/utils/env';

export function usePromoComposable() {
  const userAuthorizationsStore = useUserAuthorizationsStore();
  const authorizations: any = userAuthorizationsStore.permissionByRole;
  const canEditPromo = authorizations?.configurationPage?.promos_edit;
  const canCreatePromo = authorizations?.configurationPage?.promos_create;
  const canEditConfigurableItem = authorizations?.configurationPage?.configurable_items_edit;
  const canEditAdminSetup = authorizations?.configurationPage?.email_notification_edit;
  const getDataPriview = (data, language, fields) => {
    const fieldsToGetData = fields || [
      {
        label: 'renderImage',
        field: 'image'
      },
      {
        label: 'title',
        field: 'title'
      },
      {
        label: 'subTitle',
        field: 'subTitle'
      },
      {
        label: 'description',
        field: 'desc'
      },
      {
        label: 'terms',
        field: 'terms'
      }
    ];
    const dataPreview = {};
    fieldsToGetData.forEach((field) => {
      dataPreview[field.label] = data[`${field.field}${language.replace(/^\w/, (c) => c.toUpperCase())}`];
    });
    return dataPreview;
  };

  const BASE_URL = getEnvVar('VITE_CDN_BASE_URL');
  const buttonIconExpand = `${BASE_URL}/assets/images/expand.svg`;
  const buttonIconCollapse = `${BASE_URL}/assets/images/collapse.svg`;
  const buttonIcon = `${BASE_URL}/assets/images/arrow.svg`;

  return {
    canEditPromo,
    canCreatePromo,
    canEditConfigurableItem,
    canEditAdminSetup,
    getDataPriview,
    buttonIconExpand,
    buttonIconCollapse,
    buttonIcon
  };
}
